import { useToast } from "@/app/components/ui/use-toast"
import {
  ITabGame,
  ITopupGameDetail,
  ITopupPackage,
  ITopupSelectedData,
  ITopupServer
} from "@/app/interfaces/ITopup"
import TopupService from "@/app/services/services/TopupService"
import { useTranslation } from "next-i18next"
import { useRouter } from "next/router"
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState
} from "react"
import { initSelectedData } from ".."
import { Input } from "@/app/components/ui/input"
import { Button } from "@/app/components/ui/button"
import { LoadingBtnComponent } from "@/app/components/loading-btn"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/app/components/ui/select"
import { TOPUP_STEP } from "../topup.constant"
import useGAEventsTracker from "@/app/hooks/useGAEventsTracker"
import { convertObjectToArray } from "@/app/utils"
import { AppContext } from "@/app/context"
import { IconClose } from "@/app/components/icon-tsx/IconClose"
import { LoadingTopup } from "./LoadingTopup"
import game from "@/pages/game"

interface TopupUserInfoProps {
  gameDetail: ITopupGameDetail & ITopupServer
  selectedData: ITopupSelectedData
  setSelectedData: Dispatch<SetStateAction<ITopupSelectedData>>
  setSelectedTab: Dispatch<SetStateAction<ITabGame | undefined>>
  setSourcePackageAndTab: Dispatch<SetStateAction<ITopupPackage | undefined>>
  setStep: Dispatch<SetStateAction<number>>
  handleSetExtendData: (value: {
    alreadyGoldGift: number
    totalLimit: number
  }) => void
  setListPackageType: (value: "image" | "text") => void
}

export const ConfirmIdStep: React.FC<TopupUserInfoProps> = ({
  gameDetail,
  selectedData,
  setSelectedData,
  setSourcePackageAndTab,
  setSelectedTab,
  setStep,
  handleSetExtendData,
  setListPackageType
}) => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const router = useRouter()
  const { userInfo } = useContext(AppContext)
  const [userID, setUserID] = useState<string>("")
  const [listServer, setListServer] = useState<any>([])
  const [listPlatform, setListPlatform] = useState<any>([])
  const [role, setRole] = useState<{ role_id: string; role_name: string }[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [errorInputValue, setErrorInputValue] = useState<string>("")
  const GAEventsTracker = useGAEventsTracker("Store_TopupGame")
  const OptionRole = role.map(
    (item: { role_id: string; role_name: string }) => ({
      title: item?.role_name,
      value: item?.role_id
    })
  )

  const OptionCountry = gameDetail?.country_list
    ? Object.entries(gameDetail?.country_list).map(([key, value]) => ({
        value: key,
        title: value
      }))
    : []

  useEffect(() => {
    if (router.query.slug_name) {
      setListServer([])
      setListPlatform([])
      setRole([])
      setSelectedData(initSelectedData)
    }
  }, [router, setSelectedData])
  const disablebtn = () => {
    if (!userID) {
      return true
    } else {
      if (
        selectedData.selectRole.role_id &&
        selectedData.selectServer.server_id
      ) {
        return false
      }
      if (!listServer.length) {
        return false
      }
      return true
    }
  }

  useEffect(() => {
    if (
      !!selectedData?.selectServer?.server_id &&
      !!selectedData?.selectUser?.user_id &&
      router?.query?.slug_name !== "napla"
    ) {
      if (listPlatform?.length > 0) {
        if (selectedData?.selectPlatform?.platform_id) {
          getRoleByServerAndUserId(
            String(router?.query?.slug_name),
            selectedData?.selectServer?.server_id,
            selectedData?.selectUser?.user_id,
            selectedData?.selectPlatform?.platform_id
          )
        }
      } else {
        getRoleByServerAndUserId(
          String(router?.query?.slug_name),
          selectedData?.selectServer?.server_id,
          selectedData?.selectUser?.user_id
        )
      }
    }
  }, [
    selectedData?.selectServer?.server_id,
    selectedData?.selectUser?.user_id,
    selectedData?.selectPlatform?.platform_id,
    listPlatform,
    router
  ])

  const onChangeText = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (
      !!selectedData?.selectUser?.user_id &&
      selectedData?.selectUser?.user_id !== e?.target?.value
    ) {
      setListServer([])
      setListPlatform([])
      setRole([])
      setSelectedData(initSelectedData)
      setUserID(e?.target?.value)
    } else {
      setUserID(e?.target?.value)
      if (e?.target?.value === "") {
        setSelectedData({
          ...selectedData,
          selectUser: {
            user_id: "",
            username: ""
          }
        })
        setRole([])
        setListServer([])
        setListPlatform([])
      }
    }
    setErrorInputValue("")
  }

  const submitGetRole = (e: any) => {
    if (!userID?.trim()) {
      setErrorInputValue(
        t("topup.error_select_userid", {
          value: gameDetail?.is_copub === "yes" ? "User Id" : "Gamota Username"
        })
      )
    }
    if (e.keyCode == 13 && !!userID.trim()) {
      getServerUserAndPlatformByUserId({
        slug_name: String(router?.query?.slug_name),
        user_id: userID?.trim()
      })
    }
  }

  // chọn xong user_id thì get về server_id và platform
  const getServerUserAndPlatformByUserId = async (params: {
    slug_name: string
    user_id: string
  }) => {
    try {
      setLoading(true)
      const res = await TopupService.getServerUserAndPlatformByUserId(params)
      if (res?.data?.errorCode === 0) {
        GAEventsTracker("Store_Topup_IDinput", "Search User info")
        if (res?.data?.data?.user?.user_id) {
          const data = res?.data?.data
          setSelectedData({
            ...selectedData,
            selectUser: data?.user
          })
          setListServer(() =>
            Object.entries(data?.servers).map(([server_id, server_name]) => ({
              title: server_name,
              value: server_id
            }))
          )

          if (data?.platform) {
            setListPlatform(() =>
              Object.entries(data?.platform ?? {}).map(
                ([platform_id, platform_name]) => ({
                  title: platform_name,
                  value: platform_id
                })
              )
            )
          }
        } else {
          setErrorInputValue(t("profile.no_data"))
        }
      } else {
        toast({
          title: res?.data?.message || t("message.DEFAULT_ERROR"),
          variant: "error"
        })
      }
      setLoading(false)
    } catch (err: any) {
      toast({
        title:
          err?.data?.message ||
          err?.response?.data?.message ||
          t("message.DEFAULT_ERROR"),
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  // khi chọn user_id và server_id thì get về role_id
  const getRoleByServerAndUserId = async (
    slug_name: string,
    server_id: string,
    user_id: string,
    platform?: string
  ) => {
    setLoading(true)
    try {
      const param = platform
        ? {
            slug_name,
            server_id,
            user_id,
            platform
          }
        : {
            slug_name,
            server_id,
            user_id
          }
      const res = await TopupService.getRoleByServerAndUserId(param)
      if (res?.data?.errorCode === 0) {
        setRole(res?.data?.data)
        setSelectedData({
          ...selectedData,
          selectRole: res?.data?.data[0]
        })
      } else toast({ title: res?.data?.message, variant: "error" })
      setLoading(false)
    } catch (err: any) {
      toast({
        title: err?.data?.message ?? err?.response?.data?.message,
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  const SelectInput = ({
    listItem,
    title,
    placeholder,
    onSelect,
    value,
    classname
  }: {
    listItem: any
    title: string
    placeholder: string
    onSelect?: (param: any) => void
    value: string
    classname?: string
  }) => {
    return (
      <div className={`mt-[24px] ${classname}`}>
        <h2 className="text-[16px] pb-[8px] pl-[24px]">{title}:</h2>
        <Select onValueChange={onSelect} value={value}>
          <SelectTrigger className="h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 dark:bg-white/10 text-[16px]">
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent>
            {listItem?.map((item: any, index: number) => {
              return (
                <SelectItem
                  value={item?.value}
                  key={item?.value}
                  className="p-3 hover:!bg-bg-disable hover:!text-main-01 text-base Nunito-600 focus:bg-bg-disable focus:text-main-01 dark:hover:!bg-[#F1F1FC]/[.1] dark:focus:!bg-[#F1F1FC]/[.1]"
                >
                  {item?.title}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>
      </div>
    )
  }

  //lọc ra các tab game không có package nào Active
  const filterTabGames = (packageAndTab: ITopupPackage) => {
    if (packageAndTab?.tabGame && packageAndTab?.tabGame?.length > 0) {
      const _filterList = packageAndTab?.tabGame?.filter((tab) => {
        const filterObject = Object.fromEntries(
          Object.entries(packageAndTab?.packages).filter(([key]) =>
            tab.package.includes(key)
          )
        )

        const _package = convertObjectToArray(filterObject)

        if (_package?.length) {
          return true
        }
        return false
      })

      return _filterList
    }
    return []
  }

  // khi đủ role_id và server_id thì get list package và tablist
  const getSourcePackageAndTab = async (
    slug_name: string,
    user_id?: string,
    server_id?: string,
    role_id?: string,
    platform?: string
  ) => {
    setLoading(true)
    try {
      const res = await TopupService.getSourcePackageAndTab({
        slug_name,
        user_id: user_id ? user_id : selectedData?.selectUser?.user_id,
        server_id: server_id
          ? server_id
          : selectedData?.selectServer?.server_id,
        role_id: role_id ? role_id : selectedData?.selectRole?.role_id,
        platform: platform
          ? platform
          : selectedData?.selectPlatform?.platform_id
      })
      if (res?.data?.errorCode === 0) {
        const data = res?.data?.data
        if (!!data?.extendData) {
          handleSetExtendData(data?.extendData)
        }
        const listTabGames = filterTabGames(data)
        setSourcePackageAndTab({
          ...data,
          tabGame: listTabGames
        })
        if (!!data?.tabGame) {
          setSelectedTab(listTabGames[0])
        }
        if (data?.list_package_type) {
          setListPackageType(data?.list_package_type)
        }
        setStep(TOPUP_STEP.PACKAGE_METHOD)
      } else {
        toast({ title: res?.data?.message, variant: "error" })
      }
    } catch (err: any) {
      toast({
        title: err?.data?.message ?? err?.response?.data?.message,
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  // khi đủ role_id và server_id thì get list package và tablist
  const getSourcePackageAndTabInOpenGlobal = async (slug_name: string) => {
    setLoading(true)
    try {
      const res = await TopupService.getSourcePackageAndTabInOpenGlobal({
        slug_name,
        country_code: selectedData?.country_code || ""
      })

      if (res?.data?.errorCode === 0) {
        const data = res?.data?.data
        if (!!data?.extendData) {
          handleSetExtendData(data?.extendData)
        }
        const listTabGames = filterTabGames(data)
        setSourcePackageAndTab({
          ...data,
          tabGame: listTabGames
        })
        if (!!data?.tabGame) {
          setSelectedTab(listTabGames[0])
        }
        if (data?.list_package_type) {
          setListPackageType(data?.list_package_type)
        }
        setStep(TOPUP_STEP.PACKAGE_METHOD)
      } else {
        toast({ title: res?.data?.message, variant: "error" })
      }
    } catch (err: any) {
      toast({
        title: err?.data?.message ?? err?.response?.data?.message,
        variant: "error"
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!!gameDetail?.last_transaction?.username) {
      setUserID(gameDetail?.last_transaction?.username || "")
    } else if (gameDetail?.is_copub === "no") {
      setUserID(userInfo?.username)
    } else {
      setUserID("")
    }
  }, [
    gameDetail?.is_copub,
    gameDetail?.last_transaction?.username,
    userInfo?.username
  ])

  useEffect(() => {
    if (
      selectedData.selectUser?.user_id &&
      selectedData.selectServer?.server_id &&
      router?.query?.slug_name === "napla"
    ) {
      getSourcePackageAndTab(
        "napla",
        userInfo.userid,
        userInfo.userid,
        userInfo.userid
      )
    }
  }, [router, userInfo, selectedData, getSourcePackageAndTab])

  return (
    <div className="md:mt-[64px] md:max-w-[450px] mx-auto flex flex-col h-full w-full flex-1 pb-[48px]">
      {/* enter username */}
      {router.query?.slug_name === "napla" ? (
        <div>
          <LoadingTopup />
        </div>
      ) : (
        <>
          <div className="relative">
            <p className="text-[16px] pb-[8px] md:pl-[24px]">
              {t("topup.input_id", {
                field: gameDetail?.is_copub === "yes" ? "Id" : "Username"
              })}
              :
            </p>
            <div className="relative">
              <Input
                onBlur={submitGetRole}
                placeholder={t("topup.input_user_id", {
                  field:
                    gameDetail?.is_copub === "yes"
                      ? "User ID"
                      : "Gamota Username"
                })}
                className="h-[52px] px-[24px] py-[13px] rounded-[16px] border border-black/10 text-[16px] dark:bg-white/10"
                onChange={onChangeText}
                onKeyDown={submitGetRole}
                value={userID?.trim()}
              />
              {!!userID && (
                <IconClose
                  className="absolute cursor-pointer top-[35%] w-[16px] h-[16px] right-[16px]"
                  onClick={() => {
                    setUserID("")
                  }}
                />
              )}
            </div>

            {errorInputValue && (
              <p className="text-xs text-main-red Nunito-400 absolute -bottom-4 pl-[6px]">
                {errorInputValue}
              </p>
            )}
          </div>

          {/* Select country if gameDetail?.open_global = 'yes' */}
          {!!listServer?.length && gameDetail?.open_global === "yes" && (
            <>
              <div className="max-w-[343px] w-full mx-auto mt-[24px] border border-dashed border-black/10 dark:border-white/10 h-[1.5px]"></div>
              <SelectInput
                listItem={OptionCountry}
                title={t("store.select_country")}
                placeholder={t("store.select_country")}
                value={selectedData?.country_code || ""}
                onSelect={(value) => {
                  setSelectedData({
                    ...selectedData,
                    country_code: value
                  })
                }}
              />
            </>
          )}

          {/* Select server */}
          {!!listServer?.length && (
            <>
              {gameDetail?.open_global === "no" && (
                <div className="max-w-[343px] w-full mx-auto mt-[24px] border border-dashed border-black/10 dark:border-white/10 h-[1.5px]"></div>
              )}
              <SelectInput
                listItem={listServer}
                title={t("topup.server")}
                placeholder={t("topup.server")}
                value={selectedData.selectServer.server_id}
                onSelect={(value) => {
                  GAEventsTracker(
                    "Store_Topup_Selectserver",
                    "Search User info"
                  )
                  setSelectedData({
                    ...selectedData,
                    selectServer: {
                      server_id: value,
                      server_name:
                        listServer?.find((item: any) => item?.value === value)
                          ?.title ?? ""
                    }
                  })
                }}
              />
            </>
          )}

          {/* Select platform */}
          {!!listPlatform?.length && (
            <SelectInput
              listItem={listPlatform}
              title={t("topup.platform")}
              placeholder={t("topup.platform")}
              value={selectedData.selectPlatform.platform_id}
              onSelect={(value) => {
                setSelectedData({
                  ...selectedData,
                  selectPlatform: {
                    platform_id: value,
                    platform_name:
                      listPlatform?.find((item: any) => item?.value === value)
                        ?.title ?? ""
                  }
                })
              }}
            />
          )}

          {!!role?.length && (
            <SelectInput
              listItem={OptionRole}
              title={t("topup.name_role")}
              placeholder={t("topup.name_role")}
              classname="mb-[32px] md:mb-[0px]"
              value={selectedData.selectRole.role_id}
              onSelect={(value) => {
                setSelectedData({
                  ...selectedData,
                  selectRole: role?.find((item) => item?.role_id === value) ?? {
                    role_id: "",
                    role_name: ""
                  }
                })
              }}
            />
          )}

          <Button
            variant="main"
            onClick={() => {
              if (!selectedData?.selectUser?.user_id) {
                getServerUserAndPlatformByUserId({
                  slug_name: String(router?.query?.slug_name),
                  user_id: userID?.trim()
                })
              } else if (
                !selectedData?.country_code &&
                gameDetail?.open_global === "yes"
              ) {
                toast({
                  title: t("store.select_country"),
                  variant: "error"
                })
              } else if (
                gameDetail?.open_global === "yes" &&
                selectedData?.country_code !== "VN"
              ) {
                getSourcePackageAndTabInOpenGlobal(gameDetail?.slug_name)
              } else {
                getSourcePackageAndTab(gameDetail?.slug_name)
              }
            }}
            disabled={disablebtn()}
            className="mx-auto mt-auto mb-0 md:mt-[32px] text-[14px] w-full md:w-[106px] h-[45px] leading-[19px] rounded-[16px]"
          >
            {loading ? <LoadingBtnComponent /> : t("reward.confirm")}
          </Button>
        </>
      )}
    </div>
  )
}
